/**
 * /admin/v1/health/* API 客户端 · M13 系统健康 / 降级率（W6）
 */
import { useQuery } from "@tanstack/react-query";

import { apiClient } from "@/lib/api-client";

export interface ModuleCount {
	module: string;
	count: number;
}

export interface DegradationSummary {
	window_hours: number;
	total_traces: number;
	degraded_traces: number;
	degradation_rate: number;
	handoff_rate: number;
	by_module: ModuleCount[];
	by_outcome: Record<string, number>;
	threshold: number;
	alert: boolean;
	since: string;
	until: string;
}

export function useDegradationSummary(params: {
	merchant_id?: string;
	window_hours?: number;
	threshold?: number;
}) {
	return useQuery<DegradationSummary>({
		queryKey: ["admin", "health", "degradation", params],
		queryFn: async () => {
			const { data } = await apiClient.get<DegradationSummary>("/admin/v1/health/degradation", {
				params: {
					...(params.merchant_id ? { merchant_id: params.merchant_id } : {}),
					window_hours: params.window_hours ?? 24,
					threshold: params.threshold ?? 0.2,
				},
			});
			return data;
		},
	});
}
